import {ReactNode, useEffect, useState} from 'react';

import useMediaQuery from 'hooks/useMediaQuery';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setPreviewSrcAC} from 'store/imageUploader/imageUploaderSlice';

import {OverviewHeaderDesktop} from './OverviewHeaderDesktop/OverviewHeaderDesktop';
import {OverviewHeaderMobileTablet} from './OverviewHeaderMobileTablet/OverviewHeaderMobileTablet';

interface IProps {
  name: string;
  description: string;
  country: string;
  city: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  facebook: string;
  instagram: string;
  logo?: string | null;
  kind?: string;
  handleEdit: () => void;
  IconElement?: ReactNode;
}

const OverviewHeader = (attributes: IProps) => {
  const dispatch = useSetGlobalState();
  const isDesktopScreen = useMediaQuery('(min-width: 992px)');

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (isDesktopScreen) setIsDropdownOpen(false);

    return () => {
      dispatch(setPreviewSrcAC(undefined));
    };
  }, [isDesktopScreen, dispatch]);

  const overviewProps = {...attributes, isDropdownOpen, setIsDropdownOpen};

  return isDesktopScreen ? (
    <OverviewHeaderDesktop {...overviewProps} />
  ) : (
    <OverviewHeaderMobileTablet {...overviewProps} />
  );
};

export default OverviewHeader;
